import FloorPlanDetail from '../components/FloorPlanDetail';

export default function FloorPlan31DuplexPage() {
  const floorPlanData = {
    id: '3-1-duplex',
    title: '3+1 Dubleks Daire',
    totalArea: '155 m²',
    rooms: '3 Yatak Odası + 1 Salon + Dubleks',
    image: '/plan-3-1-duplex.png',
    description: 'İki katlı modern yaşamın tüm avantajlarını sunan dubleks dairemiz, alt katta geniş bir sosyal alan (salon ve mutfak), üst katta ise mahrem yatak odaları ile mükemmel bir fonksiyonellik sunar. Modern iç merdiven tasarımı ve her iki katta bulunan banyoları ile konforludur.',
    roomDetails: [
      { name: 'Alt Kat - Salon', dimensions: '5.20 x 7.00 m', area: '36.40 m²' },
      { name: 'Alt Kat - Mutfak', dimensions: '3.40 x 4.00 m', area: '13.60 m²' },
      { name: 'Üst Kat - Ana Yatak Odası', dimensions: '4.20 x 4.80 m', area: '20.16 m²' },
      { name: 'Üst Kat - Yatak Odası 1', dimensions: '3.40 x 4.00 m', area: '13.60 m²' },
      { name: 'Üst Kat - Yatak Odası 2', dimensions: '3.20 x 3.80 m', area: '12.16 m²' },
      { name: 'Alt Kat - WC / Banyo', dimensions: '2.00 x 2.60 m', area: '5.20 m²' },
      { name: 'Üst Kat - Ana Banyo', dimensions: '2.60 x 3.20 m', area: '8.32 m²' },
      { name: 'Üst Kat - Balkon', dimensions: '1.40 x 4.50 m', area: '6.30 m²' },
      { name: 'Teras', dimensions: '3.50 x 4.00 m', area: '14.00 m²' },
      { name: 'Koridorlar & Merdiven', dimensions: '-', area: '25.26 m²' }
    ],
    features: [
      'İki katlı modern mimari',
      'Modern iç merdiven tasarımı',
      'Alt ve üst katta ayrı banyolar',
      'Geniş tavan yüksekliği',
      'Üst kat teras keyfi',
      'Ebeveynlere özel üst kat mahremiyeti',
      'Akıllı ev kontrol sistemi',
      'Yerden ısıtma'
    ]
  };

  return <FloorPlanDetail data={floorPlanData} />;
}
